import {
  bumiCheckoutABTestRouteConfig,
  getABTestConfig,
} from '@/config/abTestConfig'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'

export default function CheckoutOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/checkout"
      routeConfig={bumiCheckoutABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      validVariants={['baseline']}
    />
  )
}
